module.exports = __webpack_public_path__ + "img/service-256.29a5405c.png";